import { Component, inject } from "@angular/core";
import { QlikService } from "../../services/qlik.service";
import { HjelpetekstComponent } from "@husbanken/designsystem-angular-core";

@Component({
  selector: "stat-kommunefilter",
  templateUrl: "./kommunefilter.component.html",
  imports: [HjelpetekstComponent],
})
export class KommunefilterComponent {
  kommuneFylkeValgt = "fylke";

  qlikService = inject(QlikService);

  selectedFylkeKommune($event) {
    let i = 0;
    if (this.kommuneFylkeValgt === "fylke") {
      this.kommuneFylkeValgt = "kommune";
      i = 1;
    } else {
      this.kommuneFylkeValgt = "fylke";
    }
    this.qlikService.setVariableNum("vVisKommuner", i);
  }
}
